import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FuelSupplierAttachmentGetRecord } from 'src/app/shared';
import { FuelSupplierAttachmentService } from 'src/app/shared/services/fuel-supplier-attachment-service';
import { ConfirmationDialogComponent } from 'src/components/shared/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/components/shared/error-dialog/error-dialog.component';

@Component({
  selector: 'app-fuel-supplier-attachments-dialog',
  templateUrl: './fuel-supplier-attachments-dialog.component.html',
  styleUrl: './fuel-supplier-attachments-dialog.component.scss',
})
export class FuelSupplierAttachmentsDialogComponent implements OnInit {
  dialogTitle: string = 'Attachments';
  addedFiles: FuelSupplierAttachmentGetRecord[] = [];
  isDownloaded = false;
  isRemoving = false;
  maxLength = false;
  maxLengthFileTitle = 100;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FuelSupplierAttachmentsDialogComponent>,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fuelSupplierAttachmentService: FuelSupplierAttachmentService
  ) {}

  ngOnInit(): void {
    this.getAttachments(this.data.fuelSupplierId);
  }

  handleFileInput(event: Event) {
    this.isDownloaded = true;
    if (event) {
      const eventTarget = (event.target as HTMLInputElement).files as FileList;
      this.fuelSupplierAttachmentService
        .uploadAttachment(
          this.data.fuelSupplierId,
          Object.values(eventTarget)[0] as File
        )
        .subscribe({
          next: () => {
            this.isDownloaded = false;
            this.snackBar.open('File uploaded.', undefined, {
              duration: 2000,
            });
            this.getAttachments(this.data.fuelSupplierId);
            (event.target as HTMLInputElement).value = '';
          },
          error: (error) => {
            this.handleError(error);
            this.isDownloaded = false;
          },
        });
    }
  }

  getAttachments(id: number) {
    this.fuelSupplierAttachmentService.getAttachments(id).subscribe((data) => {
      const sortedData = data.sort((a, b) => {
        if (a.originalFileName.toLocaleLowerCase() < b.originalFileName.toLocaleLowerCase()) return -1;
        if (a.originalFileName.toLocaleLowerCase() > b.originalFileName.toLocaleLowerCase()) return 1;
        return 0;
      });

      this.addedFiles = sortedData;

      this.maxLength = this.addedFiles.length >= 50;
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  removeFile(id: number) {
    this.isDownloaded = true;
    this.isRemoving = true;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Attention',
        message: `Are you sure you want to delete this record?`,
        buttons: {
          cancel: 'Cancel',
          confirm: 'Delete',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        this.fuelSupplierAttachmentService
          .deleteAttachment(id)
          .subscribe(() => {
            this.isDownloaded = false;
            this.isRemoving = false;
            this.getAttachments(this.data.fuelSupplierId);
          });
      } else {
        this.isDownloaded = false;
      }
    });
  }

  downloadFile(id: number) {
    this.fuelSupplierAttachmentService
      .getAttachmentDownloadUrl(id)
      .subscribe((response) => {
        window.open(response.url, '_blank');
      });
  }

  checkLength(value: string): string {
    if (value?.length >= this.maxLengthFileTitle) {
      return value.slice(0, this.maxLengthFileTitle);
    } else {
      return value;
    }
  }

  handleError(error: any) {
    this.dialog
      .open(ErrorDialogComponent, {
        data: { message: error.error.Message },
      })
      .afterClosed()
      .subscribe(() => this.getAttachments(this.data.fuelSupplierId));
  }
}
